
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"m0 0h24v24h-24z"}})]),_c('g',{attrs:{"clip-path":"url(#a)","fill":"#4a3428","stroke":"#4a3428","stroke-width":".115096"}},[_c('path',{attrs:{"d":"m18.3579 11.8649v9.9175h-16.76574v-16.76571h10.08624.0239l.0168-.01685 1.5346-1.53462.0983-.09824h-.139-11.67838c-.42227 0-.827245.16775-1.125834.46634-.298589.29858-.4663341.70356-.4663341 1.12583v16.88075c0 .4223.1677451.8273.4663341 1.1259.298589.2985.703564.4663 1.125834.4663h16.88078c.4223 0 .8272-.1678 1.1258-.4663.2986-.2986.4664-.7036.4664-1.1259v-11.5096-.1389l-.0983.0982-1.5346 1.5346-.0168.0169z"}}),_c('path',{attrs:{"d":"m18.2827.675296-.0001.000063-10.5198 10.581141-.01158.0117-.00369.016-.85171 3.6907h-.00002l-.0003.0015c-.03798.1873-.03399.3806.01169.5661.04567.1855.13189.3586.25245.5068s.27247.2679.4448.3503c.17142.0821.35881.1253.54883.1267.09755.0105.19597.0104.2935-.0003l.00004.0003.00606-.0013 3.72143-.8211.0166-.0036.0119-.012 10.4965-10.59633c.0001-.00004.0001-.00007.0001-.00011.1204-.12008.2159-.26273.2811-.41977.0652-.1571.0988-.32551.0988-.4956 0-.17008-.0336-.3385-.0988-.49559-.0652-.1571-.1607-.29978-.2812-.41989l-2.5857-2.585714c-.1201-.120434-.2628-.215986-.4199-.281183-.1571-.065196-.3255-.098756-.4956-.098756-.17 0-.3385.03356-.4956.098756-.1571.065197-.2997.160749-.4198.281183zm.9262 5.580724-7.8739 7.91968-2.70254.5981.62764-2.6804 7.8664-7.91979zm-.0257-4.16156 2.0972 2.09725-1.123 1.11588-2.0829-2.08295z"}})])])
          )
        }
      }
    